function FeatureIntro({ children }) {
  return (
    <div className="py-8 lg:py-12">
      <div className="container mx-auto">{children} </div>
    </div>
  );
}
export default FeatureIntro;
